export default [
  {
    component: () => import('./pages/Entry.vue'),
    meta: {
      metaTags: [
        {
          content: 'Discover what keywords are trending now on Etsy! Updated daily, we flag yesterday’s most popular search terms and show you last month’s Top 100 most-searched keywords for each platform, along with 15-month trend graphs of historical data.',
          name: 'description',
        },
        {
          page_slug: 'trending',
        },
      ],
      requiresAuth: true,
      title: 'eRank — Trending',
    },
    name: 'trending',
    path: '/trending/:marketplace?/:category?/:date?',
  },
];
